import StudentTaskResult from './model';
import create from './create';

StudentTaskResult.create = create;

export default StudentTaskResult;



// WEBPACK FOOTER //
// ./data/StudentTasks/StudentTaskResult/index.js